import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Testimonials() {
  const testimonials = [{
    name: 'Dorina',
    role: 'Învățătoare',
    text: 'Dorina se simțea confuză, nemulțumită de viața ei. A ales să se lase ghidată de mine în Programul Deblocare emoțională... Și-a descoperit tiparele repetitive care o mențineau blocată în trecut și îi creau senzația de confuzie. Și-a descoperit menirea, a făcut schimbări semnificative care au atras admirația soțului ei.'
  }, {
    name: 'Dana',
    role: 'Antreprenor',
    text: 'Dana era războinică, avea senzația că trebuie să lupte cu ceilalți, cu viața. Odată vindecate rănile create involuntar, inconștient în trecut, a reușit să atingă starea de pace și liniște interioară pe care și le dorea. Colegele fiicelor ei o numesc mama zen.'
  }, {
    name: 'Lavinia',
    role: 'Medic',
    text: 'Nu multi oameni din viața mea au văzut peste gard. Stela, pot sa spun că m-ai citit ca pe o carte deschisă, chiar daca uneori au fost doar niste pagini la întâmplare, după cum s-a deschis cartea. Da, după Programul de Comunicare și Relationare văd altfel lucrurile, oamenii, viața. Viata mea.'
  }, {
    name: 'Ramona',
    role: 'Antreprenor',
    text: 'Ei bine, m-am simțit invitată la o introspecție pe care nu aș fi făcut-o dacă nu îmi era cerută în acest moment. O analiză a tuturor tiparelor comportamentale, mă face să înțeleg că în final toți suntem imperfecți și în același timp toți suntem prefecți și minunați.'
  }, {
    name: 'Iulia',
    role: 'Antreprenor',
    text: 'După ce am ieșit din zoom, am sărit în sus și i-am zis soțului meu: deci a fost wow. Nu îmi vine să cred ce tare mi-a plăcut tot ce s-a petrecut acolo. Și cât de fericită sunt că am spus DA acestui program.'
  }, {
    name: 'Daniela',
    role: 'Ofițer',
    text: 'Eu as vrea să vă multumesc pt cursul pe care l-am facut cu dvs. Nici acum nu-mi vine sa cred ca am reușit să trec peste un obstacol dupa 14 ani și acum am mai multă încredere în mine. Va multumesc, Stela Lucuța.'
  }];
  return <section className="bg-cream py-12 md:py-20" data-id="element-321">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8" data-id="element-322">
        <FadeIn data-id="element-323">
          <div className="text-center max-w-[720px] mx-auto mb-16 md:mb-24" data-id="element-324">
            <h2 className="text-[32px] md:text-[48px] font-medium leading-[1.15] mb-6" data-id="element-325">
              Transformări reale din programele mele
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-326">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-327">
              <div className="bg-cream-alt border border-plum-border rounded-[16px] p-8 md:p-10 shadow-card h-full flex flex-col relative" data-id="element-328">
                <span className="absolute top-6 left-6 text-[80px] font-fraunces italic text-plum opacity-10 leading-none select-none" data-id="element-329">
                  "
                </span>

                <p className="font-fraunces italic text-[18px] md:text-[20px] text-plum leading-[1.5] mb-8 relative z-10 flex-grow pt-4" data-id="element-330">
                  {testimonial.text}
                </p>

                <div className="mt-auto flex items-center gap-4" data-id="element-331">
                  <div className="w-12 h-12 rounded-full bg-plum/10 flex items-center justify-center text-plum font-poppins font-semibold" data-id="element-332">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div data-id="element-333">
                    <div className="font-poppins font-semibold text-plum text-[16px]" data-id="element-334">
                      {testimonial.name}
                    </div>
                    <div className="font-inter text-warmgray text-[14px]" data-id="element-335">
                      {testimonial.role}
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}